module.exports = {"name":"nodeClick","on":[{"events":[{"type":"click","markname":"singleNodeSymbols"},{"type":"click","markname":"singleNodeValues"}],"update":"datum.datum || datum","force":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/signals/outputs/node-click.json
// module id = Rz8d
// module chunks = 0